import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityOidcConfigurationsBySubdomainGetSlice } from './get';

export const securityOidcConfigurationsBySubdomainReducers = combineReducers({
	get: securityOidcConfigurationsBySubdomainGetSlice.asyncReducers
});

export const securityOidcConfigurationsBySubdomainWatchers = combineAllWatchers([
	securityOidcConfigurationsBySubdomainGetSlice.asyncWatchers
]);
